import RangeLimits from '@scripts/components/RangeLimits';
import FormPartial from '@scripts/forms/FormPartial';
import IcrasHelpers from '@scripts/helpers';

/**
 * "HealthStatus" form partial
 */
export default class extends FormPartial {

	/**
   * If the components are being refreshed
   *
   * @private
   *
   * @type {bool}
   */
  #isRefresh = false;

	/**
   * Medication for hbp
   *
   * @private
   *
   * @type {HTMLLabelElement}
   */
  #bpmedication;

	/**
   * systolic blood pressure
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #sbp;

	/**
   * Diabetes duration
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #dd;

	/**
   * HbA1c
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #hba1c;

	/**
   * LDL Cholesterol
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #ldlc;

	/**
   * Triglycerides
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #triglycerides;

	/**
   * urine ACR
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #uacr;

	/**
   * C-reactive protein
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #crp;

	/**
   * eGFR
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #egfr;

	/**
   * hscrp
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #hscrp;

	/**
   * Smoke
   *
   * @private
   *
   * @type {HTMLLabelElement}
   */
  #smoke;

	/**
   * Alcohol
   *
   * @private
   *
   * @type {HTMLLabelElement}
   */
  #alcohol;

  constructor(form) {
    super(form);

		this.#isRefresh = false;

		this.#bpmedication = this._form.element.querySelector('#icrasBpMedication');
		this.#smoke = this._form.element.querySelector('#icrasSmoke');
		this.#alcohol = this._form.element.querySelector('#icrasAlcohol');

		this.#sbp = new RangeLimits(
      this._form.element.querySelector('#icrasSbp')
    );

		this.#dd = new RangeLimits(
      this._form.element.querySelector('#icrasDd')
    );

		this.#hba1c = new RangeLimits(
      this._form.element.querySelector('#icrasHba1c')
    );

		this.#ldlc = new RangeLimits(
      this._form.element.querySelector('#icrasLdlc')
    );

		this.#triglycerides = new RangeLimits(
      this._form.element.querySelector('#icrasTriglycerides')
    );

		this.#uacr = new RangeLimits(
      this._form.element.querySelector('#icrasUacr')
    );
		
		this.#crp = new RangeLimits(
      this._form.element.querySelector('#icrasCrp')
    );

		this.#egfr = new RangeLimits(
      this._form.element.querySelector('#icrasEgfr')
    );

		this.#hscrp = new RangeLimits(
      this._form.element.querySelector('#icrasHscrp')
    );

  }
 
  initialize() {
   
  }

  validate() {
    this._resetMessages();

    let errors = [];

    this.addErrors(errors);

    return super.validate();
  }

  reset() {
    super.reset();

		/**
     * Reset Toggle components
     *
     * Family History
     * Diabetes mellitus
     */
    [this.#bpmedication, this.#smoke, this.#alcohol].forEach((label) => {
      label
        .querySelectorAll('input[type="checkbox"]:checked')
        .forEach((input) => {
          input.checked = false;
          // for toggle
          input.dispatchEvent(new Event('change'));
        });
    });

		[this.#sbp, this.#dd, this.#hba1c, this.#ldlc, this.#triglycerides, this.#uacr, this.#crp, this.#egfr, this.#hscrp].forEach(
      (range) => range.reset()
    );

  }

	setEgfrValue(value) {
		this.#egfr.setRangeValue(value);
	}

	getCrpSliderValue() {
		return this.#crp.getValue();
	}

	onCrpChange(value) {
		this.#crp.on('updateValue', value);
	}

	offCrpChange(value) {
		this.#crp.off('updateValue', value);
	}

		/**
   * function for auto eGFR toggle
   *
   * @return {void}
   */
 	toggleAutoEgfr(isEnabled) {
		if (isEnabled) {
			this.#egfr.disable();
		} else {
			this.#egfr.enable();
			this.#egfr.setRangeValue(0);
		}
	}
	
}
